// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"cc07f9e9","404":"1372a316","787":"63719bea"}[chunkId] + ".chunk.js";
};